/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// Register $ global var for jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

import 'select2';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */


// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component('log-in-out', require('./components/LogOutHandler.vue').default);
Vue.component('products-list', require('./components/ProductsList.vue').default);
Vue.component('program-list', require('./components/ProgramList.vue').default);
Vue.component('maintenance', require('./components/Maintenance.vue').default);
Vue.component('subscription-renewal', require('./components/SubscriptionRenewals.vue').default);

Vue.component('licences-setup', require('./components/LicencesSetup.vue').default);
Vue.component('cart-steps', require('./components/CartSteps.vue').default);
Vue.component('user-info', require('./components/UserInfo.vue').default);
Vue.component('user-info-input', require('./components/UserInfoInput.vue').default);
Vue.component('software-languages', require('./components/SoftwareLanguage.vue').default);
Vue.component('single-upgrade', require('./components/SingleUpgrade.vue').default);
Vue.component('lease-prolong', require('./components/LeaseProlong.vue').default);
Vue.component('select2', require('./components/Select2.vue').default);
Vue.component('single-upgrade-key', require('./components/SingleUpgradeKey.vue').default);
Vue.component('cart-dropdown', require('./components/Cart.vue').default);
Vue.component('cart-update', require('./components/CartUpdate.vue').default);
Vue.component('cart-info', require('./components/CartSummary.vue').default);
Vue.component('cart-info-licences', require('./components/CartSummary/CartSummaryLicences.vue').default);
Vue.component('cart-info-perpetual-upgrade', require('./components/CartSummary/CartSummaryPerpetualUpgrade.vue').default);
Vue.component('cart-info-subscription-customization', require('./components/CartSummary/CartSummarySubscriptionCustomization.vue').default);
Vue.component('cart-info-prolong-customization', require('./components/CartSummary/CartSummaryProlongCustomization.vue').default);
Vue.component('user-level', require('./components/UserLevel.vue').default);
Vue.component('promo', require('./components/Promo.vue').default);

Vue.component('setup-summary-licences', require('./components/LicenceSetup/SetupSummaryLicences.vue').default);
Vue.component('setup-new', require('./components/LicenceSetup/NewLicencesSetup.vue').default);
Vue.component('setup-prolong', require('./components/LicenceSetup/ProlongLicencesSetup.vue').default);
Vue.component('setup-upgrade', require('./components/LicenceSetup/UpgradeNewSoftwarePerpetual.vue').default);



/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import store from './store.js';

import _ from 'lodash';
import {isNil} from "lodash/lang";


Vue.mixin({
    methods: {
        priceFormat(price, show = false, decimals = false)
        {
            let currency = window.shopConfigOptions.currency;
            price = Number(price) || 0;
            if (Number(price) == 0 && show == false) {
                return '';
            }
            let decimalCount = 2;
            //(currency == 'EUR' || currency == 'USD' ) &&
            if (decimals == true) {
                decimalCount = 2;
            } else if (price % 1 == 0) {
                decimalCount = 0;
            }

            let decimal = window.priceFormatOptions.price_decimal_format;
            let thousands = window.priceFormatOptions.price_thousands_format;
            let format = window.priceFormatOptions.currency_format;
            format = unescape(format);

            let i = parseInt(price = Math.abs(Number(price) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            let value = (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(price - i).toFixed(decimalCount).slice(2) : "");
            return format.replace('{value}', value).replace(/&nbsp;/gi," ");
        },
        getProgramBasePrice(id, currency, product, type = 'local_quantity') {
            if (currency == '') {
                currency = window.shopConfigOptions.currency;
            }
            let program = window.jsonProducts[product].items.find(p => p.id == id);
            if (typeof program == "undefined") {
                return 0;
            }
            if (typeof program.price_list == "undefined") {
                return 0;
            }
            let perpetualTypes = ['local_quantity', 'cloud_perpetual_quantity', 'network_quantity'];

            if (perpetualTypes.includes(type) ) {
                return Number(program.price_list[currency]) || 0;
            } else {
                return Number(program.lease_price_list[currency]) || 0;
            }

        },
        getProgramMaintenancePrice(id, currency, product, type = 'local_quantity', quantity = 1) {
            quantity = Number(quantity) || 0;
            let programPrice = this.getProgramPrice(id, currency, 'cloud_perpetual_quantity', product, quantity);
            return (programPrice * window.jsonProducts[product].maintenance_percent/100) || 0 ;
        },
        getProductMaintenancePrice(product, currency = '') {
            if (_.isNil(this.$store.state.cart.maintenance)) {
                return 0;
            }
            if (_.isNil(this.$store.state.cart.maintenance[product])) {
                return 0;
            }
            if (currency == '') {
                currency = window.shopConfigOptions.currency;
            }
            if (_.isNil(this.$store.state.cart.maintenance[product]['totalCurrency'])) {
                return 0;
            }
            if (_.isNil(this.$store.state.cart.maintenance[product]['totalCurrency'][currency])) {
                return 0;
            }
            return this.$store.state.cart.maintenance[product]['totalCurrency'][currency];
        },
        getDeliveryPrice(userInfo, currency = '') {
            if (currency == '') {
                currency = window.shopConfigOptions.currency;
            }
            let priceList = window.worldDeliveryPrices;

            if (_.isNil(priceList[currency])) {
                return 0;
            }
            return Number(priceList[currency] || 0);
        },

        getTruss4Price(id, currency = 'EUR', type = 'local_quantity', product = 1, quantity = 1, ignoreLease = false) {
            let basePrice = this.getProgramBasePrice(id, currency, product);
            let period = 12;

            if (this.hasTruss4GraceLease(product)) {
                basePrice = basePrice * Number(window.jsonProducts[product].grace_lease_agreement.months) / 12
            } else if (this.hasTruss4Lease(product)) {
                basePrice = basePrice * Number(window.jsonProducts[product].active_lease_agreement.months) / 12
            } else {
                period = this.$store.state.cart.trussPeriod;
                basePrice = basePrice * period  /12;
            }
            let qty = Number(quantity) || 0;

            if (this.hasTruss4Lease(product) == false || ignoreLease) {
                if (qty > 1) {
                    return basePrice +  basePrice * 10/100 * (qty - 1);
                } else if (qty == 1) {
                    return basePrice;
                } else {
                    return 0
                }
            } else {
                return basePrice * 10/100 * qty ;
            }
        },
        translateLeaseEnd(months) {
            let count = months;
            let str = 'months';
            if (months/12 >= 1) {
                count = months/12;
                str = 'years';
            }
            return this.getPluralTranslation('front', 'subscription_renewal_box_period_'+str+'_plural',count);
        },
        productHasNetwork(product = 1) {
            return window.jsonProducts[product].purchase_options.has_network || true;
        },
        isTruss4Product(productId) {
            if (_.isNil(productId) || _.isNil(window.jsonProducts[productId]) || _.isNil(window.jsonProducts[productId].purchase_options)) {
                return false;
            }
            let specialPrice = window.jsonProducts[productId].purchase_options.special_price || false;
            if (specialPrice == 'truss4') {
                return true;
            }
            return false;
        },
        hasTruss4Lease(productId) {
            if (_.isNil(productId) || _.isNil(window.jsonProducts[productId]) || _.isNil(window.jsonProducts[productId].active_lease_agreement)) {
                return false;
            }
            if (!_.isNil(window.jsonProducts[productId].active_lease_agreement)) {
                return true;
            }

            return false;
        },
        hasTruss4GraceLease(productId) {
            if (_.isNil(productId) || _.isNil(window.jsonProducts[productId]) || _.isNil(window.jsonProducts[productId].grace_lease_agreement)) {
                return false;
            }
            if (!_.isNil(window.jsonProducts[productId].grace_lease_agreement)) {
                return true;
            }

            return false;
        },
        getLocalCoefficient(product = 1) {
            return Number(window.jsonProducts[product].localMultiplier) || 1;
        },
        getNetworkCoefficient(product = 1) {
            return Number(window.jsonProducts[product].networkMultiplier) || 1;
        },
        getCloudCoefficient(product = 1) {
            return Number(window.jsonProducts[product].cloudMultiplier) || 1;
        },
        getProgramPrice(id, currency = 'EUR', type = 'local_quantity', product = 1, quantity = 1, special = false, discount = 0, days = false) {
            if (this.isTruss4Product(product) && special == false) {
                return this.getTruss4Price(id, currency, type, product, quantity);
            }
            let basePrice = this.getProgramBasePrice(id, currency, product, type);
            let price = basePrice;

            let userType = window.shopUserTypes.find(u => u.type == this.$store.state.cart.userLevel);
            price = price * ((100 - discount) / 100);

            if (type === 'local_quantity') {
                price = this.roundCurrency(price);
                price = price * userType['localPriceCoefficient'] / 100;
                return Math.floor( price)  * Number(quantity) || 0;
            } else if (type === 'network_quantity') {
                price = this.roundCurrency(price);
                price = price * Number(userType['networkPriceCoefficient']) / 100;
                return Math.floor( price)  * Number(quantity) || 0;
            } else if (type === 'lease_local_quantity') {
                price = this.roundCurrency(price);
                price = price * userType['localPriceCoefficient'] / 100;
                return Math.floor( price) * Number(quantity) || 0;
            } else if (type === 'lease_network_quantity') {
                price = this.roundCurrency(price);
                price = price * userType['networkPriceCoefficient'] / 100;
                return Math.floor( price) * Number(quantity) || 0;
            } else if (type === 'cloud_perpetual_quantity') {
                price = this.roundCurrency(price);
                price = price * Number(userType['cloudPriceCoefficient']) / 100;
                return Math.floor( price) * Number(quantity) || 0;
            } else if (type === 'cloud_time_quantity') {
                price = this.roundCurrency(price);
                price = price * Number(userType['cloudPriceCoefficient']) / 100;
                if (days !== false) {
                    price = days/365 * price
                }
                return Math.floor( price) * Number(quantity) || 0;
            }
        },
        roundCurrency(total) {
            return total;
            let currency = window.shopConfigOptions.currency
            let roundValue = Number(window.roundSettings[currency]);
            return Math.floor( (Number(total) / roundValue) + 0.5 ) * roundValue;
        },
        getQtyName(type = 'perpetual', licenceType = 'local') {
            if (licenceType === 'local' && type === 'perpetual') {
                return 'local_quantity';
            }
            if (licenceType === 'local' && type === 'lease') {
                return 'lease_local_quantity';
            }

            if (licenceType === 'cloud' && type === 'perpetual') {
                return 'cloud_perpetual_quantity';
            }
            if (licenceType === 'cloud' && type === 'lease') {
                return 'cloud_time_quantity';
            }

            if (licenceType === 'network' && type === 'perpetual') {
                return 'network_quantity';
            }
            if (licenceType === 'network' && type === 'lease') {
                return 'lease_network_quantity';
            }

            return 'local_quantity';
        },
        getSingleUpgradePrice(program) {
            let currency = window.shopConfigOptions.currency;
            if (!_.isNil(program.priceList) && !_.isNil(program.priceList[currency])) {
                return program.priceList[currency];
            }
            return 0;
        },
        getLanguagePrice(id, currency, product) {
            let basePrice = this.getProgramBasePrice(id, currency, product);
            let languageMulti = window.jsonProducts[product].languagePriceMultiplier;
            return Number(basePrice) * Number(languageMulti) / 100;
        },
        getProgramName(id, product) {
            let program = window.jsonProducts[product].items.find(p => p.id == id);
            if (_.isNil(program)) {
                return '';
            }
            return program.name;
        },
        getProgramOrder(id, product) {
            let program = window.jsonProducts[product].items.find(p => p.id == id);
            if (_.isNil(program)) {
                return '';
            }
            return program.sortOrder;
        },

        getHardlockPrice(h, currency = '') {
            if (currency == '') {
                currency = window.shopConfigOptions.currency;
            }
            if (_.isNil(h['price_list'][currency])) {
                return 0;
            }
            return Number(h['price_list'][currency] || 0);
        },
        getTranslation(file, str, params = {}) {
            let translation = window.i18n[file][str];
            if (_.isEmpty(params)) {
                return translation
            }
            _.forIn(params, function(value, key) {
                translation = translation.replaceAll(':' + key, value);
            });

            return translation;
        },
        getPluralTranslation(file, str, count = 1, params = {}) {
            let translation = window.i18n[file][str];
            let plurals = translation.split('|');
            let trans = '';
            _.forEach(plurals, function(value) {
                let separator = value.indexOf('}');

                let rule = value.substring(0, separator+1);

                trans = value.substring(separator+1);

                rule = rule.replace('{', '').replace('}', '');

                if (rule.indexOf(',')>0) {
                    let range = rule.split(',');
                    if (range[0] == '*') {
                        range[0] = '-2000000000';
                    }
                    if (range[1] == '*') {
                        range[1] = '2000000000';
                    }
                    if (count >= range[0] && count <= range[1]) {
                        return false;
                    }
                } else {
                    if (count == rule) {
                        return false;
                    }
                }
            });


            params['count'] = count;
            _.forIn(params, function(value, key) {
                trans = trans.replaceAll(':' + key, value);
            });

            return trans;
        },
        setSpinner() {
            $(".continue").each(function() {
                $(this).addClass('d-none');
            });
            $(".continue-spinner").each(function() {
                $(this).removeClass('d-none').addClass('d-flex');
            });
        },
        resetSpinner() {
            $(".continue").each(function() {
                $(this).removeClass('d-none');
            });
            $(".continue-spinner").each(function() {
                $(this).removeClass('d-flex').addClass('d-none');
            });
        }
    }
})

const myVue = new Vue({
    el: '#app',
    store: new Vuex.Store(store)
});

window.myVue = myVue;



